import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

import DropdownItem from '../DropdownItem/DropdownItem'
import { chunkArray } from '../../utils/chunkArray'

import {
  HoverLine,
  StyledAside,
  StyledAsideContainer,
  StyledDropdown,
  StyledDropdownHeader,
  StyledDropdownItems,
  StyledDropdownList,
  StyledSeparator,
  StyledSubDropdownItems,
} from './Dropdown.styled'

const getColumns = (
  links,
  selectedColumn,
  setSelectedColumn,
  selectedItem,
  setSelectedItem
) => {
  const chunkedItems = chunkArray(links, 6)
  const columns = []

  chunkedItems.forEach((chunk, chunkedItemsIndex) => {
    const column = []
    const items = []
    const subColumns = []

    chunk.forEach((link, index) => {
      const subItems = []
      if (link.pageReference === null && link.slug === null) return
      items.push(
        <DropdownItem
          key={link.id}
          columnId={chunkedItemsIndex}
          hasSubItems={link.subNavigationItems}
          itemId={index}
          setSelectedColumn={setSelectedColumn}
          selectedColumn={selectedColumn}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          slug={link.pageReference?.slug ?? link.slug}
          title={link.name}
        />
      )
      link.subNavigationItems?.forEach((subItem, index) => {
        subItems.push(
          <DropdownItem
            key={subItem.id}
            slug={subItem.pageReference?.slug ?? link.slug}
            title={subItem.name}
            itemId={index}
          />
        )
      })
      subColumns.push(subItems)
    })

    const subColumnsItems = subColumns.map((subColumn, index) => {
      return (
        <StyledSubDropdownItems
          $isVisible={index === selectedItem}
          key={`subColumn-${index}`}
        >
          {subColumn}
        </StyledSubDropdownItems>
      )
    })

    const isOpen = selectedColumn === columns.length
    const last = columns.length + 1 === chunkedItems.length

    column.push(
      <Fragment key={chunk[0].id}>
        <StyledDropdownItems>{items}</StyledDropdownItems>
        <StyledSeparator $isVisible={columns.length + 1 < chunkedItems.length} />
        <StyledAsideContainer $isOpen={isOpen} $last={last}>
          <StyledAside $isOpen={isOpen} $last={last}>
            {subColumnsItems}
          </StyledAside>
        </StyledAsideContainer>
      </Fragment>
    )
    columns.push(column)
  })

  return columns
}

const Dropdown = (props) => {
  const { label, links, slug, isSelected, scroll } = props
  const [isOpen, setIsOpen] = useState(false)
  const [selectedColumn, setSelectedColumn] = useState(null)
  const [selectedItem, setSelectedItem] = useState(null)
  const getItems = getColumns(
    links,
    selectedColumn,
    setSelectedColumn,
    selectedItem,
    setSelectedItem
  )

  return (
    <StyledDropdown
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => {
        setSelectedColumn(null)
        setSelectedItem(null)
        setIsOpen(false)
      }}
    >
      {/* link */}
      <StyledDropdownHeader>
        <Link to={`/${slug}`}>{label}</Link>
        {scroll ? null : <HoverLine $isOpen={isOpen} $selected={isSelected} />}
      </StyledDropdownHeader>
      {/* sub-links */}
      <StyledDropdownList $isOpen={isOpen}>
        {getItems.slice(0, 5)}
      </StyledDropdownList>
    </StyledDropdown>
  )
}

Dropdown.propTypes = {
  label: PropTypes.string.isRequired,
  links: PropTypes.array.isRequired,
  slug: PropTypes.string.isRequired,
}

export default Dropdown
